import { GlobalStorage } from "@otto-ec/global-client-storage";
import { o_global } from "../namespaces";

/*🤫*/
o_global.Storage ||= GlobalStorage;
